import { FormGroup, ValidatorFn } from '@angular/forms';

export class FormValidators {
    static rangeValidator: ValidatorFn = (fg: FormGroup) => {
        const min = fg.get('min')?.value;
        const max = fg.get('max')?.value;
        return min !== null && max !== null && min > max ? { rangeValidator: true } : null;
    }

    static greaterThanZero: ValidatorFn = (fg: FormGroup) => {
        const value = fg.value;
        return value !== null && value <= 0 ? { greaterThanZero: true } : null;
      };
}
